<template>
 <!-- 审核记录 -->
 <div>
    <el-dialog title="记录"
    @close="closeDialog"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :visible.sync="recordMark"
    width="550px"
    center>
      <span>
        <el-timeline>
          <el-timeline-item  v-for="(activity, index) in activities" :key="index" :color="activities.length-1 ? '#0bbd87' : ''">
            <p>审核时间：{{activity.createTime|dateFormat}}</p>
            <p>审核人：{{activity.createUserName}}</p>
            <p>审核操作：{{[ "待审核", "审核通过", "审核驳回" ,"不审核"][activity.auditStatus]}}</p>
            <p v-if="activity.auditOpinion">审核结果：{{activity.auditOpinion}}</p>
          </el-timeline-item>
        </el-timeline>
      </span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="recordMark = false"  size='mini'>取 消</el-button>
      </span>
    </el-dialog>
     <!-- 审核 -->
    <wayDrawer :rowData="addFrom"  v-if="drawerFlag"  @destroy="destroy" @successFn="successFn"> </wayDrawer>
 </div>
</template>

<script>
import { auditRecordsList } from '@/api/soc-customer'
export default {
  name: 'shenheJilu',
  props: {
    rowData: {
      type: Object,
      default: function () {
        return {}
      }
    }
  },
  data () {
    return {
      dialog: false,
      activities: [],
      recordMark: false,
      drawerFlag: false,
      addFrom: {},
    }
  },
  mounted: function () { // 在更新DOM之前 调用此钩子函数 应用：可以获取原始的DOM
    this.recordClick(this.rowData) 
    },
  methods: {
    // 审核记录
    recordClick (row) {
      this.title = '记录'
      this.recordMark = true
      auditRecordsList({
        wayId: row.id
      }).then(res => {
        this.activities = res
      }).catch(err => {
        DonMessage.error(err.message)
      })
    },
    closeDialog () {
      this.$emit('destroy')
    }
  },
  destroyed () {

  }
}
</script>

<style scoped lang='less'>
.hidden /deep/.el-upload--picture-card{
  display: none;
}
/deep/.el-form--inline .diqu .el-form-item__content{
      flex-direction: row;
}
/deep/.el-image {
  margin: 10px;
}
</style>
